import { render, staticRenderFns } from "./lastPage.vue?vue&type=template&id=45959ee7&scoped=true&"
import script from "./lastPage.vue?vue&type=script&lang=js&"
export * from "./lastPage.vue?vue&type=script&lang=js&"
import style0 from "./lastPage.vue?vue&type=style&index=0&id=45959ee7&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45959ee7",
  null
  
)

export default component.exports